import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { TableActionItems } from '../datatable/TableActionItems';
import '../../style/DataTable.css';

const ActionableTeamsDataTable = (props) => {
  const getActionableTeamData = () => {
    let rowData = [];
    props.actionableTeams.map((row) =>
      rowData.push({
        name: row.name ? row.name : 'N/A',
        clubName: row.clubName ? row.clubName : 'N/A',
        numberOfPlayers: row.players.length,
        actions: (
          <TableActionItems editAction={() => props.editAction(row.id)} />
        ),
      })
    );
    if (!rowData.length) {
      return null;
    }

    return {
      columns: [
        {
          label: 'Nimi',
          field: 'name',
        },
        {
          label: 'Klubi nimi',
          field: 'clubName',
        },
        {
          label: 'Mängijate arv',
          field: 'numberOfPlayers',
        },
        {
          label: '',
          field: 'actions',
        },
      ],
      rows: rowData,
    };
  };
  const tableData = getActionableTeamData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default ActionableTeamsDataTable;
